const DB_NAME = 'FundDB';
const DB_VERSION = 3; // 升级版本
const STORE_NAME = 'funds';
const HOLDINGS_STORE_NAME = 'holdings'; // 新增持仓存储

export const db = {
  async open() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = (event) => reject(event.target.error);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (db.objectStoreNames.contains(STORE_NAME)) {
          const store = request.transaction.objectStore(STORE_NAME);
          if (store.keyPath !== 'code') {
            db.deleteObjectStore(STORE_NAME);
            db.createObjectStore(STORE_NAME, { keyPath: 'code' });
          }
        } else {
          db.createObjectStore(STORE_NAME, { keyPath: 'code' });
        }
        // 创建持仓存储
        if (!db.objectStoreNames.contains(HOLDINGS_STORE_NAME)) {
          db.createObjectStore(HOLDINGS_STORE_NAME, { keyPath: 'code' }); // 使用 code 作为主键
        }
      };

      request.onsuccess = (event) => resolve(event.target.result);
    });
  },

  // ... 现有方法保持不变 ...
  async getAllFunds() {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.getAll();

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },
  
  async getFundByCode(code) {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(code);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },
  
  // 获取持仓数据
  async getHoldings(code) {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([HOLDINGS_STORE_NAME], 'readonly');
      const store = transaction.objectStore(HOLDINGS_STORE_NAME);
      const request = store.get(code);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },

  // 保存持仓数据
  async saveHoldings(code, stocks) {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([HOLDINGS_STORE_NAME], 'readwrite');
      const store = transaction.objectStore(HOLDINGS_STORE_NAME);
      // 保存数据 + 时间戳
      const data = {
        code: code,
        stocks: stocks,
        updatedAt: Date.now()
      };
      const request = store.put(data);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },

  async addFund(fund) {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.add(fund);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },

  async updateFund(fund) {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(fund);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },

  async deleteFund(code) {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete(code);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },

  async clearFunds() {
    const db = await this.open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.clear();

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  },

  async initMockData(mockData) {
    const funds = await this.getAllFunds();
    if (funds.length === 0) {
      const db = await this.open();
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      for (const fund of mockData) {
        store.add(fund);
      }
      return new Promise((resolve) => {
        transaction.oncomplete = () => resolve(true);
      });
    }
    return false;
  }
};
